/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductView,
    MelcoFusionModelsCustomProductViewFromJSON,
    MelcoFusionModelsCustomProductViewFromJSONTyped,
    MelcoFusionModelsCustomProductViewToJSON,
    MelcoFusionModelsUserBlank,
    MelcoFusionModelsUserBlankFromJSON,
    MelcoFusionModelsUserBlankFromJSONTyped,
    MelcoFusionModelsUserBlankToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCreateCustomProduct
 */
export interface MelcoFusionModelsCreateCustomProduct {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCreateCustomProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCreateCustomProduct
     */
    token?: string | null;
    /**
     * 
     * @type {MelcoFusionModelsUserBlank}
     * @memberof MelcoFusionModelsCreateCustomProduct
     */
    blank?: MelcoFusionModelsUserBlank;
    /**
     * 
     * @type {Array<MelcoFusionModelsCustomProductView>}
     * @memberof MelcoFusionModelsCreateCustomProduct
     */
    view_list?: Array<MelcoFusionModelsCustomProductView> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCreateCustomProduct
     */
    configurator_version?: number | null;
}

export function MelcoFusionModelsCreateCustomProductFromJSON(json: any): MelcoFusionModelsCreateCustomProduct {
    return MelcoFusionModelsCreateCustomProductFromJSONTyped(json, false);
}

export function MelcoFusionModelsCreateCustomProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCreateCustomProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'blank': !exists(json, 'blank') ? undefined : MelcoFusionModelsUserBlankFromJSON(json['blank']),
        'view_list': !exists(json, 'view_list') ? undefined : (json['view_list'] === null ? null : (json['view_list'] as Array<any>).map(MelcoFusionModelsCustomProductViewFromJSON)),
        'configurator_version': !exists(json, 'configurator_version') ? undefined : json['configurator_version'],
    };
}

export function MelcoFusionModelsCreateCustomProductToJSON(value?: MelcoFusionModelsCreateCustomProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'token': value.token,
        'blank': MelcoFusionModelsUserBlankToJSON(value.blank),
        'view_list': value.view_list === undefined ? undefined : (value.view_list === null ? null : (value.view_list as Array<any>).map(MelcoFusionModelsCustomProductViewToJSON)),
        'configurator_version': value.configurator_version,
    };
}


